module.exports = __webpack_public_path__ + "static/datamanCN-d0015366e2c8bdf270367bc657abe715.png";